import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box } from '~/commonComponents';

export interface IFeatureCardProps {
  icon: string;
  title: string;
  description: string;
  descriptionWidth?: number;
}

export const FeatureCard = ({
  icon,
  title,
  description,
  descriptionWidth = 200,
}: IFeatureCardProps) => {
  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding={16}
      width={272}
      minHeight={160}
    >
      <img src={icon} width={56} height={56} style={{ marginBottom: 16 }} />
      <Typography as="span" size="body_large" bold textAlign="center" color={colors.primary[500]} style={{ marginBottom: 8 }}>
        {title}
      </Typography>
      <Typography as="span" size="caption" textAlign="center" style={{ width: descriptionWidth }}>
        {description}
      </Typography>
    </Box>
  );
};
